import cx from 'clsx';

import { EnvironmentRibbon } from '..';
import { TProps } from '../types/TProps';

export const EnvironmentRibbonDev = ({ className, ...props }: TProps) => (
  <EnvironmentRibbon {...props} className={cx('env-ribbon--dev', className)} />
);
